import { htmlATexto } from '../../lib/textoEnriquecido.js';

export const MAX_ATTACH_BYTES = 25 * 1024 * 1024;

export function timeAgo(ms: number): string {
  const diff = Math.max(0, Date.now() - ms);
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}

/** HTML a texto plano: la conversión única de Evo Hub (lib/textoEnriquecido.ts). */
export function htmlToText(html: string): string {
  return htmlATexto(html);
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

